import { VENDA_EM_MASSA} from '../types';

export default function informarVendaEmMassa (ehVendaEmMassa) {
  return {
    type: VENDA_EM_MASSA,
    payload: ehVendaEmMassa
  }
}
